module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-summer-of-cricket.589dc95f.jpg";